import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';

const songExist = (props) => {
  return (
    <section className='songExist'>
      <div className='title'>
        <Image src={require('./images/mark.svg')} alt='סימן קריאה' />
        <p>השיר שבחרתם קיים לכם במאגר השירים</p>
      </div>
      <p className='text'>באפשרותכם לבחור שיר אחר מקטלוג המתנה נעימה</p>
      <div className='songs-list-img'>
        <Image src={require('./images/songs.jpg')} alt='חץ' />
      </div>
      <div className='another-song' onClick={() => props.selectAnotherSong()}>
        <p>לבחירת שיר אחר</p>
        <Image src={require('./images/arrow.svg')} alt='חץ' />
      </div>
    </section>
  );
};

export default songExist;
